import api from '../config/api';

import * as LocalStorageService from './LocalStorageService';

const AUTH_HEADER = 'Authorization';

export const saveSession = sessionToken => {
  api.setHeader(AUTH_HEADER, sessionToken);
  LocalStorageService.setSessionToken(sessionToken);
};

export function authInit() {
  const currentSessionToken = LocalStorageService.getSessionToken();
  if (currentSessionToken) {
    api.setHeader(AUTH_HEADER, currentSessionToken);
    return true;
  }
  return false;
}

export const signIn = user => api.post('api/v1/users/sessions', user, { timeout: 60000 });

export function signUp(user) {
  return api.post('api/v1/users', { user });
}

export function resendVerificationCode(email, docType, docNumber) {
  const userData = docType
    ? {
        document_type: docType,
        document_number: docNumber,
        email
      }
    : { email };

  return api.post('api/v1/users/confirmation', userData);
}

export async function changePrimaryEmail(email) {
  return api.post('api/v1/users/email', { new_email: email });
}

export async function validateChangeEmail(email, code) {
  return api.put('api/v1/users/email', { new_email: email, confirmation_token: code });
}

export async function verifyEmail(confirmationCode, email, password, docNumber, docType) {
  return api.put('api/v1/users/confirmation/async', {
    confirmation_token: confirmationCode,
    email,
    password,
    document_type: docType,
    document_number: docNumber
  });
}

export function signOut() {
  LocalStorageService.removeSessionToken();
  api.setHeader(AUTH_HEADER);
}

export async function newPasswordRequest(userInfo) {
  return api.post('api/v1/users/new_password_request', userInfo);
}

export async function changePassword(currentPwd, pwd, pwdConfirm) {
  return api.put('api/v1/users/password', {
    user: {
      current_password: currentPwd,
      password: pwd,
      password_confirmation: pwdConfirm
    }
  });
}

export async function getIdentityValidationForm(userInfo) {
  return api.post('api/v1/users/validation_questions', userInfo);
}

export async function validateIdentityAnswers(answers) {
  return api.post('api/v1/users/validation_answers', answers);
}

export async function getUserInformation() {
  return api.get('api/v1/users/async');
}

export async function getUserProfile() {
  return api.get('api/v1/users/profile');
}

export async function updateUserProfile(userInfo, password) {
  return api.put('api/v1/users/profile', { additional_information: userInfo, password });
}
export async function validateToken(passwordRecoveryToken) {
  return api.post('api/v1/users/password/token_validation', {
    reset_password_token: passwordRecoveryToken
  });
}

export async function recoveryPassword(userInfo, resetPasswordToken, externalToken) {
  return api.put('user/password', {
    user: {
      password: userInfo.password,
      password_confirmation: userInfo.password_confirmation,
      reset_password_token: resetPasswordToken,
      external_token: externalToken
    }
  });
}

export const getUserIdentification = userData => api.post('api/v1/users/identification', userData);
